import {
  LineChart, Line, XAxis, YAxis, ResponsiveContainer, Tooltip, Legend,
} from 'recharts';
import AngledAxisTick from '../AngledAxisTick';
import AnalyticsEmptyState from "../../dashboard/AnalyticsEmptyState";

const OTHER_KEY = 'Anders, namelijk..';

const MultipleMomentLineChart = ({ data, totalResponses, graphColor }) => {
  if (!data || data.length === 0) {
    return <AnalyticsEmptyState />;
  }

  // Transform for Recharts rows; keep a hidden __others field
  const transformedData = data.map((item) => {
    const transformedResponses = item.responses.reduce((acc, response) => {
      acc[response.name] = response.count;
      return acc;
    }, {});
    return {
      name: item.moment,
      __others: item.others || [],   // ⬅️ carry the texts per moment
      ...transformedResponses,
    };
  });

  // Unique keys/colors (assumes same set across moments)
  const keysWithColors = data.length > 0
    ? data[0].responses.map((response) => ({
        key: response.name,
        color: response.color,
      }))
    : [];

  // Custom tooltip
  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;

    const row = payload[0]?.payload || {};
    const others = Array.isArray(row.__others) ? row.__others : [];

    // render each series line
    return (
      <div className="custom-tooltip">
        <p className="label">{`Meetmoment: ${label}`}</p>

        {payload.map((entry, idx) => (
          <p key={`tooltip-${idx}`} style={{ color: entry.color, margin: 0 }}>
            {`${entry.dataKey}: ${entry.value}`}
          </p>
        ))}

        {/* If hovering "Anders, namelijk.." (or it's included in the set), show the free-text list */}
        {others.length > 0 && payload.some(p => p.dataKey === OTHER_KEY) && (
          <div style={{ marginTop: 8 }}>
            <ul style={{ paddingLeft: 16, margin: '4px 0' }}>
              {others.slice(0, 5).map((txt, i) => (
                <li key={`other-${i}`}>{String(txt)}</li>
              ))}
            </ul>
            {others.length > 5 && (
              <div style={{ fontStyle: 'italic' }}>
                +{others.length - 5} meer…
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart
          data={transformedData}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <XAxis dataKey="name" axisLine={false} tickLine={false} stroke={graphColor || 'black'} tick={<AngledAxisTick fill={graphColor || undefined} />} interval={0} height={70} />
          <YAxis allowDecimals={false} axisLine={false} tickLine={false} stroke={graphColor || 'black'} tick={{ fill: graphColor || undefined }} />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ color: graphColor || undefined }} />

          {keysWithColors.map(({ key, color }) => (
            <Line
              key={`line-${key}`}
              type="monotone"
              dataKey={key}
              stroke={color}
              activeDot={{ r: 8 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </>
  );
};

export default MultipleMomentLineChart;


  